import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { UrlService } from 'src/app/shared/services/url.service';
import { GlobalService } from 'src/app/shared/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';
import { InformacionVisitanteModel } from 'src/app/shared/models/informacionVisitante.model';


@Component({
  selector: 'modal-asociar-tarjeta-reutilizable',
  templateUrl: './modal-asociar-tarjeta-reutilizable.component.html',
  styleUrls: ['./../registro-entrada-visitante.component.scss']
})
export class ModalAsociarTarjetaReutilizableComponent implements OnInit {

  @Input() public data: InformacionVisitanteModel;

  public filtroCodigoTarjeta: string;
  public modalOptions: ConfirmationModalOptions;
  public EstadoCodigoTarjeta: string;
  public filtroTipoDocumento: string;
  public filtroNombre: string;
  public filtroDocumento: string;


  constructor(
    private activeModal: NgbActiveModal,
    private alertService: AlertService,
    private urlService: UrlService,
    private global: GlobalService,
    private spinner: NgxSpinnerService,
  ) {
    this.modalOptions =
      new ConfirmationModalOptions('Confirmación', ConstantesService.MSJ_CONFIRM_REGISTRO_CODIGO_TARJETA,
        'SI', 'NO', 'fas fa-sim-card', true, false, 'Asociar Tarjeta', null, 'btn-secondary');
  }

  ngOnInit() {

    this.filtroTipoDocumento = this.data.tipoDocumento;
    this.filtroNombre = this.data.nombreCompleto;
    this.filtroDocumento = this.data.numeroDocumento;

    if (this.data.codigoTarjeta) {
      this.filtroCodigoTarjeta = this.data.codigoTarjeta;
    }
  }

  /**
   * Método para cerrar el modal activo
   * @function close
   * @return
   */
  close() {
    this.activeModal.close();
  }

  /**
   * Método encargado de realizar la conexion con el back y enviarle los filtros necesarios
   * para realizar las consultas
   * @function getConfirmationModal
   * @param  {type} event trae la respuesta del mensaje de confirmacion TRUE o FALSE
   * @return
   */
  getConfirmationModal(event) {
    if (event[0] === true) {
      this.activeModal.close({ filtro: this.filtroCodigoTarjeta });
    }
  }

  /**
   * Método que valida si el campo donde se ingresa el codigo se encuentre con algo o no, para
   * habilitar el boton "Asociar Tarjeta"
   * @function validacion
   * @return
   */
  validacion() {
    if ((this.filtroCodigoTarjeta == undefined) || (this.filtroCodigoTarjeta == "")) {
      this.modalOptions.disabled = true;
    } else {
      // this.modalOptions.disabled = false;
      this.validarEstado();
    }
  }

  consultarEstado() {

  }

  /**
   * Método de control de Excepciones
   * @function {function name}
   * @param  {type} error                 mensaje saliente respecto al error ocurrido
   * @param  {type} err: HttpResponseBase Tipo de error
   * @return
   */
  cathException(error, err) {
    this.alertService.generateAlertError(error, "Error");
    this.spinner.hide();
  }

  validarEstado() {

    this.modalOptions.disabled = true;
    this.spinner.show();
    const serviceProvider = 'validarEstadoCodigo';

    const queryParams: Array<[string, string]> = new Array<[string, string]>();

    queryParams.push(['codigo', this.filtroCodigoTarjeta]);

    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
    this.global.getGenerico(url).subscribe(data => {


      if (data[0].mensaje == 'OK') {

        this.modalOptions.disabled = false;
      } else {
        this.alertService.generateAlertError(data[0].mensaje, '');
      }

      this.spinner.hide();

    }, (err: any) => {
      this.cathException('No es posible validar el código en este momento', 'Error');
    });

  }
}

